import { createRouter, createWebHistory } from 'vue-router'
import store, { STORAGE_KEYS } from '../store'
import { ElMessage } from 'element-plus'
import { createWebHashHistory } from 'vue-router'
import IndexView from '../views/IndexView.vue'

const routes = [
  {
    path: '/',
    name: 'index',
    component: IndexView,
    meta: {
      navbar: false,
      footer: false
    }
  },
  {
    path: '/home',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/HomeView.vue'),
    meta: {
      navbar: true,
      footer: true
    }
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
    meta: {
      navbar: true,
      footer: true
    }
  },
  {
    path: '/doctor',
    name: 'doctor',
    component: () => import(/* webpackChunkName: "doctor" */ '../views/DoctorView.vue'),
    meta: {
      navbar: true,
      footer: true
    }
  },
  {
    path: '/patient',
    name: 'patient',
    component: () => import(/* webpackChunkName: "patient" */ '../views/PatientView.vue'),
    meta: {
      navbar: true,
      footer: true
    }
  },
  {
    path: '/case',
    name: 'case',
    component: () => import(/* webpackChunkName: "case" */ '../views/CaseView.vue'),
    meta: {
      navbar: true,
      footer: true
    }
  },
  {
    path: '/report',
    name: 'report',
    component: () => import(/* webpackChunkName: "report" */ '../views/ReportView.vue'),
    meta: {
      navbar: true,
      footer: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
    meta: {
      navbar: false,
      footer: true
    }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import(/* webpackChunkName: "register" */ '../views/RegisterView.vue'),
    meta: {
      navbar: false,
      footer: true
    }
  },
  {
    path: '/info',
    name: 'info',
    component: () => import(/* webpackChunkName: "info" */ '../views/InfoView.vue'),
    meta: {
      navbar: true,
      footer: true
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

let hasReadEntryOtherId = false

// 全局前置守卫
router.beforeEach(async (to, from, next) => {
  // 页面首次打开时读取 other_id，避免退出后的路由跳转又把旧链接参数写回本地。
  if (!hasReadEntryOtherId) {
    const pageParams = new URLSearchParams(window.location.search)
    const hasPageOtherId = pageParams.has(STORAGE_KEYS.OTHER_ID)
    const hasRouteOtherId = Object.prototype.hasOwnProperty.call(to.query, STORAGE_KEYS.OTHER_ID)
    if (hasPageOtherId || hasRouteOtherId) {
      const routeOtherId = Array.isArray(to.query.other_id) ? to.query.other_id[0] : to.query.other_id
      const otherId = hasPageOtherId ? pageParams.get(STORAGE_KEYS.OTHER_ID) : routeOtherId
      localStorage.setItem(STORAGE_KEYS.OTHER_ID, String(otherId ?? ''))
    }
    hasReadEntryOtherId = true
  }

  const hasLocale = localStorage.getItem('locale')

  // if (to.path === '/' && hasLocale) {
  //   next('/home')
  //   return
  // }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLogin) {
      try {
        next()
      } catch (error) {
        console.error('验证登录状态失败:', error)
        ElMessage.error('验证登录状态失败')
        next('/home')
      }
    } else {
      ElMessage.warning('请先登录')
      next('/home')
    }
  } else {
    next()
  }
})

// 全局后置钩子
router.afterEach((to, from) => {
  // 可以在这里添加页面标题设置等
  console.log(`导航到: ${to.name}`)
})

export default router
